import { render, staticRenderFns } from "./BasicLandingPageForm.vue?vue&type=template&id=69ef7d56"
import script from "./BasicLandingPageForm.vue?vue&type=script&lang=js"
export * from "./BasicLandingPageForm.vue?vue&type=script&lang=js"
import style0 from "./BasicLandingPageForm.vue?vue&type=style&index=0&id=69ef7d56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports